import React from 'react';
import { FlowerIcon, ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { OfferCountdown } from './OfferCountdown';
type PriceSectionProps = {
  onCTA: () => void;
};
const badges = [{
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ShieldCheckIcon,
  label: 'Una sola vez'
}];
export function PriceSection({
  onCTA
}: PriceSectionProps) {
  return <section id="precio" className="w-full scroll-mt-20 bg-crema py-20 sm:py-28" data-id="element-197" data-mp="2vhyep1g3ygcj">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-198" data-mp="2qkevro8gtfe9">
        <Reveal className="text-center" data-id="element-199" data-mp="2mibfmmaupmmn">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-200" data-mp="2mjczng9uhjgi">
            Invierte en ti hoy
          </h2>
          <p className="mt-4 text-lg text-tinta/70" data-id="element-201" data-mp="kqovn4pdmrzo">
            30 días que pueden cambiar cómo te sientes en tu cuerpo. Empieza
            hoy mismo.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-202" data-mp="1mkp1631ppuon">
          <div className="mt-10 overflow-hidden rounded-[2rem] border border-nude bg-white p-8 text-center shadow-xl shadow-rosa/15 sm:p-12" data-id="element-203" data-mp="1rhfbsauqzy2o">
            <span className="mb-8 inline-flex items-center gap-2 rounded-full bg-rosa/15 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.18em] text-rosa-dark" data-id="element-204" data-mp="1djif7eganro0">
              <FlowerIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-205" data-mp="258tyarnv6heh" />
              Oferta de lanzamiento
            </span>

            <OfferCountdown data-id="element-206" data-mp="2a6vi5et46kr0" />

            <div className="mt-6 flex flex-wrap items-end justify-center gap-x-3 gap-y-2" data-id="element-207" data-mp="2aaavod753lqb">
              <span className="flex shrink-0 flex-col items-center gap-1.5" data-id="element-208" data-mp="1wgjpnesmajzc">
                <span className="flex h-16 w-16 -rotate-12 flex-col items-center justify-center rounded-full border border-rosa/40 bg-rosa/15 text-rosa-dark" data-id="element-209" data-mp="20h2er134lbxu">
                  <span className="font-serif text-xl font-semibold leading-none" data-id="element-210" data-mp="2syfztlrpl8pn">
                    65%
                  </span>
                  <span className="mt-0.5 text-[9px] font-semibold uppercase tracking-[0.12em]" data-id="element-211" data-mp="32tde7slkq8da">
                    Dcto
                  </span>
                </span>
                <span className="font-serif text-xl text-tinta/40 line-through" data-id="element-212" data-mp="2ttgum5e1jzp3">
                  24 USD
                </span>
              </span>
              <span className="pb-2 text-lg font-medium text-tinta/60" data-id="element-213" data-mp="2ounh4cyr88ox">
                USD
              </span>
              <span className="font-serif text-6xl font-semibold text-rosa-dark sm:text-7xl" data-id="element-214" data-mp="2jxx27syorj53">
                8,50
              </span>
            </div>

            <p className="glow-pulse mt-2 text-sm font-medium tracking-wide text-tinta/60" data-id="element-215" data-mp="2b4jzy0eqf56c">
              Un solo pago · Acceso de por vida
            </p>

            <CTAButton id="comenzar-transformacion" checkout onClick={onCTA} icon={FlowerIcon} size="lg" className="mt-8 w-full sm:w-auto" data-id="element-216" data-mp="262ky4uyn4gbi">
              Comenzar ahora por USD 8,50
            </CTAButton>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-tinta/70" data-id="element-217" data-mp="1r1e098psptjn">
              {badges.map(b => <span key={b.label} className="inline-flex items-center gap-1.5" data-id="element-218" data-mp="1w1s8aqred3ho">
                  <b.icon className="h-4 w-4 text-dorado" strokeWidth={1.8} data-id="element-219" data-mp="20x7mjjtbh1em" />
                  {b.label}
                </span>)}
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}